export const HELP_AND_SUPPORT_TEXT = 'Help & Support';
export const PAGE_NOT_FOUND_HEADING = 'Page Not Found';
export const PAGE_NOT_FOUND_TEXT = "We're sorry, this page does not exist.";
export const PLEASE_VISIT_TEXT = 'Please visit the ';
export const MY_ACCOUNT_TEXT = 'My Account';
export const HOMEPAGE_TEXT = ' homepage or search ';
export const LOOKING_FOR_TEXT = 'to find what you are looking for.';
